(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swatches-zoomed-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById('swatches-details-modalOverlay');
    const closeBtn = document.getElementById('swatches-details-modalCloseBtn');
    const swatchesDetailsModalContent = document.getElementById('swatches-details-modalContent');

    closeBtn.addEventListener('click', () => {
      overlay.classList.remove('active');
      document.body.classList.remove('swatches-details-modal-open');
    });

    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
      document.body.classList.remove('swatches-details-modal-open');
    });

    swatchesDetailsModalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
